export interface BlogKnowledgeQuestion {
  n: number;
  label: string;
}

export interface BlogKnowledgeLink {
  slug: string;
  topicId: string;
  topicLabel: string;
  contextLine: string;
  heading: string;
  blurb: string;
  questions: BlogKnowledgeQuestion[];
}

export const blogKnowledgeLinks: Record<string, BlogKnowledgeLink> = {
  'how-to-stop-overthinking-and-start-doing': {
    slug: 'how-to-stop-overthinking-and-start-doing',
    topicId: 'tnt-coaching',
    topicLabel: 'Coaching Styles & Use Cases',
    contextLine:
      'Overthinking is precisely what the Calm Thinking and Decision coaching styles were designed for.',
    heading: 'How TNT Coach AI handles overthinking',
    blurb:
      'If the loop keeps restarting, the app has dedicated coaching perspectives for separating facts from assumptions and for structuring a choice you keep circling.',
    questions: [
      { n: 14, label: 'What is the Calm Thinking Coach for?' },
      { n: 18, label: 'Can TNT Coach AI help with difficult decisions?' },
      { n: 16, label: 'Can TNT Coach AI help with procrastination?' },
    ],
  },
  'building-daily-discipline-that-actually-lasts': {
    slug: 'building-daily-discipline-that-actually-lasts',
    topicId: 'tnt-goals',
    topicLabel: 'Goals, Habits & Progress',
    contextLine:
      'Habit design is a first-class part of the product rather than a side feature.',
    heading: 'The habit side of TNT Coach AI',
    blurb:
      'Everything above assumes you can see whether you are actually showing up. These answers cover the habit tracker, daily use and how goals are broken down.',
    questions: [
      { n: 30, label: 'Does TNT Coach AI have a habit tracker?' },
      { n: 35, label: 'Can I use TNT Coach AI every day?' },
      { n: 26, label: 'What is Goal Coach?' },
    ],
  },
  'the-confidence-you-need-already-exists': {
    slug: 'the-confidence-you-need-already-exists',
    topicId: 'tnt-coaching',
    topicLabel: 'Coaching Styles & Use Cases',
    contextLine:
      'Confidence through repetition is the core idea behind two of the eight coaching perspectives.',
    heading: 'Where confidence gets coached',
    blurb:
      'The Action & Confidence and Champion Mindset styles both exist to turn hesitation into reps — here is what each one is actually for.',
    questions: [
      { n: 17, label: 'Can TNT Coach AI help with confidence?' },
      { n: 9, label: 'What is the Action & Confidence Coach for?' },
      { n: 10, label: 'What is the Champion Mindset Coach for?' },
    ],
  },
  'why-your-goals-arent-working-and-how-to-fix-them': {
    slug: 'why-your-goals-arent-working-and-how-to-fix-them',
    topicId: 'tnt-goals',
    topicLabel: 'Goals, Habits & Progress',
    contextLine:
      'Goal Coach exists to turn a broad ambition into weekly milestones and a first action.',
    heading: 'How goals are structured in the app',
    blurb:
      'The bridge method is easier to hold when something tracks the planks. These answers cover the goal tooling and what the app will and will not decide for you.',
    questions: [
      { n: 26, label: 'What is Goal Coach?' },
      { n: 29, label: 'Does TNT Coach AI track progress?' },
      { n: 36, label: 'Does TNT Coach AI tell users exactly what to do?' },
    ],
  },
  'how-to-make-better-decisions-under-pressure': {
    slug: 'how-to-make-better-decisions-under-pressure',
    topicId: 'tnt-coaching',
    topicLabel: 'Coaching Styles & Use Cases',
    contextLine:
      'The pause protocol maps closely to how the Decision and Calm Thinking coaches are meant to be used.',
    heading: 'The decision tools behind this article',
    blurb:
      'If you want the structure without doing it in your head, Decision Coach walks the choice with you step by step.',
    questions: [
      { n: 25, label: 'What is Decision Coach?' },
      { n: 18, label: 'Can TNT Coach AI help with difficult decisions?' },
      { n: 14, label: 'What is the Calm Thinking Coach for?' },
    ],
  },
  'from-procrastination-to-momentum-in-10-minutes': {
    slug: 'from-procrastination-to-momentum-in-10-minutes',
    topicId: 'tnt-features',
    topicLabel: 'Features & How It Works',
    contextLine:
      'There is a dedicated tool for the exact resistance this article describes.',
    heading: 'Meet the Procrastination Breaker',
    blurb:
      'The 10-minute sprint works on your own, but the app has a purpose-built flow for naming what you are avoiding and shrinking it.',
    questions: [
      { n: 27, label: 'What is the Procrastination Breaker?' },
      { n: 16, label: 'Can TNT Coach AI help with procrastination?' },
      { n: 9, label: 'What is the Action & Confidence Coach for?' },
    ],
  },
};